export default __webpack_public_path__ + "static/media/Oversized_printing_rules_inches.ce4c8833.pdf";